import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2.5 cursor-pointer group"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-compass-3-line text-2xl ${isHome && !scrolled ? 'text-background-50' : 'text-primary-500'} transition-colors`}></i>
            </div>
            <span className={`text-lg font-heading font-semibold whitespace-nowrap ${
              isHome && !scrolled ? 'text-background-50' : 'text-foreground-900'
            } transition-colors`}>
              正品蓝导航
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {[
              { to: '/', label: '首页' },
              { to: '/category/shopping', label: '分类导航' },
              { to: '/about', label: '关于我们' },
            ].map((item) => {
              const isActive = item.to === '/' ? location.pathname === '/' : location.pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    isActive
                      ? isHome && !scrolled
                        ? 'bg-background-50/20 text-background-50'
                        : 'bg-primary-100 text-primary-700'
                      : isHome && !scrolled
                        ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                        : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer rounded-lg ${
              isHome && !scrolled ? 'text-background-50' : 'text-foreground-700'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {[
              { to: '/', label: '首页' },
              { to: '/category/shopping', label: '分类导航' },
              { to: '/about', label: '关于我们' },
            ].map((item) => {
              const isActive = item.to === '/' ? location.pathname === '/' : location.pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}